import { Icon } from '@material-ui/core';

import ContentCloudIconImage from 'Console/assets/images/icons/ContentCloudIcon.png';

interface ContentCloudIconProps {
    className: string | undefined;
}
const ContentCloudIcon = ({ className }: ContentCloudIconProps): JSX.Element => (
    <Icon className={className}>
        <img height={16} src={ContentCloudIconImage} />
    </Icon>
);

export default ContentCloudIcon;
